class Mapped {
    constructor(upstream, mapFunction) {
        this.upstream = upstream;
        this.mapFunction = mapFunction;
        this.callbacks = new WeakMap();
    }
    subscribe(cb) {
        this.callbacks.set(cb, val => {
            cb(this.mapFunction(val), this);
        });
        this.upstream.subscribe(this.callbacks.get(cb));
    }
    unsubscribe(cb) {
        this.upstream.unsubscribe(this.callbacks.get(cb));
        this.callbacks.delete(cb);
    }
}
/**
 * Creates a dependent observable that resolves to a derived value of the existing.
 *
 * @param upstream the observable whose emits should be mapped
 * @param mapFunction the map function to use
 * @returns a new observable that emits a transformed value whenever upstream emits.
 */
export function map(upstream, mapFunction) {
    return new Mapped(upstream, mapFunction);
}
